import React from 'react'
const CreditReportList = (props) => {
    const {creditReport} = props;
    const inputDate = new Date(creditReport.created_at);
    const options = {
        day: "2-digit",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "Asia/Kolkata"
    };
    const formattedDate = inputDate.toLocaleString("en-GB", options).replace(",", " at");
    return (
        <>
            <tr className="">
                <td className="align-items-center">
                    <div className="d-flex flex-column">
                        <span>
                            <div className="fw-bold">
                                {formattedDate}
                            </div>
                        </span>
                    </div>
                </td>
                <td className="align-items-center">
                    <div className="d-flex flex-column">
                        <span>
                            <div className="fw-bold">
                                {creditReport.module_name}
                            </div>
                        </span>
                    </div>
                </td>
                <td className="align-items-center">
                    <div className="d-flex flex-column">
                        <span>
                            <div className="fw-bold">
                                {creditReport.api_count}
                            </div>
                        </span>
                    </div>
                </td>
                <td>
                    <span className="me-2">
                        <div className={`badge  fw-bold mb-1 ${creditReport.payment_status==='D'? 'badge-light-danger': 'badge-light-success'}`}>
                            {
                                creditReport.payment_status==='D' ?
                                'Credit Used':
                                'Credit Added'
                            }
                        </div>
                    </span>
                </td>
                <td className='text-end'>
                    {Number(creditReport.amount).toFixed(2)}
                </td>
            </tr>
        </>
    )
}

export default CreditReportList